import { Box, InputLabel, SxProps, TextField } from "@mui/material";
import customInputStyles from "./CustomInput.styles";

interface CustomProps {
  label?: string;
  placeHolder?: string;
  value?: string;
  onChange?: any;
  type?: string;
  name?: string;
  select?: boolean;
  onKeyPress?: any;
  InputProps?: any;
  error?: any;
  required?: boolean;
  InputLabelProps?: any;
  id?: string;
  sx?: SxProps;
  customClasses?: SxProps;
  customNameFieldClasses?: SxProps;
  disabled?: boolean;
  propsToInputElement?: any;
  variant?: "filled" | "standard" | "outlined" | undefined;
  multiline?: boolean;
  rows?: number;
  autoComplete?: string;
  ref?: any;
}

const CustomInput = (props: CustomProps) => {
  const classes = customInputStyles;
  const { error = null } = props;

  return (
    <>
      {props.label && (
        <Box mb={props.label ? 1 : 0}>
          <InputLabel
            required={props.required}
            sx={
              props.customNameFieldClasses
                ? { ...classes.nameField, ...props.customNameFieldClasses }
                : classes.nameField
            }
          >
            {props.label}
          </InputLabel>
        </Box>
      )}
      <TextField
        sx={
          props.customClasses
            ? props.customClasses
            : props.sx
            ? { ...classes.textField, ...props.sx }
            : classes.textField
        }
        ref={props.ref}
        variant={props.variant}
        multiline={props.multiline}
        rows={props.rows}
        id={props.id}
        placeholder={props.placeHolder}
        type={props.type}
        name={props.name}
        select={props.select}
        value={props.value}
        autoComplete={props.autoComplete}
        InputProps={props.InputProps}
        inputProps={props.propsToInputElement}
        onChange={props.onChange}
        onKeyPress={props.onKeyPress}
        required={props.required}
        {...(error && { error: true, helperText: error })}
        disabled={props.disabled}
      />
    </>
  );
};

export default CustomInput;
